// A shared test run (the link CI puts on a PR) is read without login: its
// calls go to the daemon's /public routes with the run's share token.
let shared: { testRun: string; token: string } | null = null;

export const shareTestRun = (testRun: string, token: string) => { shared = { testRun, token }; };

/** The public path for `rest` of the shared run, or null for any other run. */
export function sharedRunPath(testRun: string, rest = ""): string | null {
  if (shared?.testRun !== testRun) return null;
  return `/public/qa-test-runs/${encodeURIComponent(testRun)}${rest}${rest.includes("?") ? "&" : "?"}share=${encodeURIComponent(shared.token)}`;
}
